import { Container } from "basis";
import { AccountHeader } from "../components/AccountHeader";
import { AccountWithPersonalDetails } from "../types";
import { AccountSectionContent } from "./AccountSectionContent";

type Props = {
  accountWithPersonalDetails: AccountWithPersonalDetails;
};

export const AccountSection = ({ accountWithPersonalDetails }: Props) => {
  const { account } = accountWithPersonalDetails;
  const testId =
    account.type === "CREDIT_CARD"
      ? `credit-card-ending-${account.credit_card?.linked_card_last4}`
      : account.type === "PERSONAL_LOAN"
      ? `personal-loan-number-${account.account_number}`
      : undefined;

  return (
    <Container hasBorder testId={testId}>
      <AccountHeader account={account} />
      <Container padding="5">
        <AccountSectionContent
          accountWithPersonalDetails={accountWithPersonalDetails}
        />
      </Container>
    </Container>
  );
};
